/* Spencer's Garage dropdown card: line each card up under its own menu word (Oct 2026). Without this the card sits at the left of the menu. */
(function () {
  function place(li) {
    var card = li.querySelector('[data-sg-menu-card]');
    if (!card) return;
    var box = card.parentElement;
    var word = li.querySelector('.menu-list__link-title') || li;
    var x = word.getBoundingClientRect().left - box.getBoundingClientRect().left;
    var max = box.clientWidth - card.offsetWidth;
    if (max < 0) max = 0;
    card.style.marginInlineStart = Math.max(0, Math.min(x, max)) + 'px';
  }
  function handler(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var li = t.closest('.menu-list__list-item');
    if (li) place(li);
  }
  document.addEventListener('pointerenter', handler, true);
  document.addEventListener('focusin', handler, true);
})();
